import styled from 'styled-components';

export const MainWrapper = styled.div`
  height: 100dvh;
  display: flex;
  flex-direction: row;
  background: #ffffff;
  width: 100dvw;
`;
